export default {
      id: "ic-para-thumb-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-thumb-usage",
      toString: function () {
        return this.url;
      }
    }